// import React, { useState, useEffect } from "react";
// import { FaArrowUp } from "react-icons/fa";
// import "./ScrollToTopButton.css";

// function ScrollToTopButton() {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const toggleVisibility = () => {
//       if (window.scrollY > 300) {
//         setIsVisible(true);
//       } else {
//         setIsVisible(false);
//       }
//     };

//     window.addEventListener("scroll", toggleVisibility);
//     return () => window.removeEventListener("scroll", toggleVisibility);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
//     isVisible && (
//       <button className="scroll-to-top" onClick={scrollToTop}>
//         <FaArrowUp />
//       </button>
//     )
//   );
// }

// export default ScrollToTopButton;


import React, { useState, useEffect } from "react";
import { FaArrowUp,FaPlane } from "react-icons/fa";
import "./ScrollToTopButton.css";

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    isVisible && (
      <button className="scroll-to-top" onClick={scrollToTop}>
        {/* <FaArrowUp /> */}
  <FaPlane style={{transform: "rotate(-90deg)" }} />
      </button>
    )
  );
}

export default ScrollToTopButton;
